import { render, staticRenderFns } from "./InformationSpace.vue?vue&type=template&id=fa87860a&scoped=true"
import script from "./InformationSpace.vue?vue&type=script&lang=js"
export * from "./InformationSpace.vue?vue&type=script&lang=js"
import style0 from "./InformationSpace.vue?vue&type=style&index=0&id=fa87860a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa87860a",
  null
  
)

export default component.exports